export default {
	global: {
		supportLink: 'https://playersupport.nexon.com/hc/en-us',
		digitalLicenseTerms: (lang = 'en') => `/main/${lang}/legal/tou`,
		tobenDigitalLicenseTerms: (lang = 'en') => {
			const tobenTermsContentID = lang === 'es' ? 1027 : 1013;
			return `https://m.nexon.com/terms/${tobenTermsContentID}`;
		},
	},
	th: {
		supportLink: 'https://th.nexon.com/help/th',
		digitalLicenseTerms: (lang = 'en') => `/main/${lang}/legal/tou`,
		tobenDigitalLicenseTerms: (lang = 'en') => {
			const tobenTermsContentID = lang === 'es' ? 1027 : 1013;
			return `https://m.nexon.com/terms/${tobenTermsContentID}`;
		},
	},
	tw: {
		supportLink: 'https://tw.nexon.com/help/zh',
		digitalLicenseTerms: (lang = 'en') => `/main/${lang}/legal/tou`,
		tobenDigitalLicenseTerms: (lang = 'en') => {
			const tobenTermsContentID = lang === 'es' ? 1027 : 1013;
			return `https://m.nexon.com/terms/${tobenTermsContentID}`;
		},
	},
	sea: {
		supportLink: 'https://sea.nexon.com/help/en',
		digitalLicenseTerms: (lang = 'en') => `/main/${lang}/legal/tou`,
		tobenDigitalLicenseTerms: (lang = 'en') => {
			const tobenTermsContentID = lang === 'es' ? 1027 : 1013;
			return `https://m.nexon.com/terms/${tobenTermsContentID}`;
		},
	},
};
